import type { SupportedLanguage } from '@/validators/procedure'
import type { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import { createContext, useContext, useState } from 'react'

export interface LanguageContext {
  language: SupportedLanguage
  setLanguage: Dispatch<SetStateAction<SupportedLanguage>>
}

const defaultLanguageContext: LanguageContext = {
  language: 'english',
  setLanguage: () => {
    throw new Error('setLanguage must be used within a LanguageProvider')
  },
}

const languageContext = createContext<LanguageContext>(defaultLanguageContext)

export function useLanguage() {
  const { language, setLanguage } = useContext(languageContext)
  return { language, setLanguage }
}

export function LanguageProvider(props: PropsWithChildren) {
  const [language, setLanguage] = useState<SupportedLanguage>('english')

  return (
    <languageContext.Provider value={{ language, setLanguage }}>
      {props.children}
    </languageContext.Provider>
  )
}
